module.exports = ClassicEditor;